import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import Dynamic_PR_table from "../../components/Dynamic_PR_table";
import { GetServiceCaller } from "../../services/serviceCaller";
import { API_URL } from "../../constants";
import { Modal, Form, OverlayTrigger, Tooltip, Table } from "react-bootstrap";
import HTMLComponent from "../../components/HtmlComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../constants/layout/store/filterSlice";
import moment from "moment";
import ExportToExcel from "../../components/ExportToExcel";
import SearchBar from "../../components/SearchBar";
import { Accordion, Card, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FaSpinner } from "react-icons/fa";
import Pagination from "../../components/Pagination";

const EmployeeHistorylist = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        dispatch(updateNavbarHeading("Employee History"));
    }, []);
    const passedState = location.state;
    const [originalData, setOriginalData] = useState([]);
    const [employeeListData, setEmployeeListData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [locationOption, setLocationOption] = useState([]);
    const [jobTitleOption, setJobtitleOption] = useState([]);
    const [statusOption, setStatusOption] = useState([]);

    const columns = [
        {
            id: "Code",
            label: "EMP ID",
            accessor: "Code",
        },
        {
            id: "ContactName",
            label: "Employee",
            accessor: "ContactName",
        },
        {
            id: "FromDate",
            label: "From",
            accessor: "FromDate",
        },
        {
            id: "ToDate",
            label: "To",
            accessor: "ToDate",
        },
        {
            id: "Department",
            label: "Department",
            accessor: "Department",
        },
        {
            id: "Designation",
            label: "Designation",
            accessor: "Designation",
        },
        {
            id: "ImmediateSuperior",
            label: "Immediate Superior",
            accessor: "ImmediateSuperior",
        },
        {
            id: "PracticeManager",
            label: "Practice Manager",
            accessor: "PracticeManager",
            // format: (val) => moment(val).format("DD-MM-YYYY"),
        },

    ];

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateNavbarHeading(`${passedState ? passedState?.text : "Employee Manager Details"} `))
    }, [passedState])

    useEffect(() => {
        fetchEmployees();
    }, []);

    useEffect(() => {
        if (originalData.length === 0) return;

        const queryParams = new URLSearchParams(location.search);
        const status = queryParams.get('Active');
        const name = queryParams.get('Name');
        const fromDate = queryParams.get('FromDate');
        const toDate = queryParams.get('ToDate');
        const RfromDate = queryParams.get('RfromDate');
        const RtoDate = queryParams.get('RtoDate');
        const filteredData = originalData.filter(item => {
            const joinDate = moment(item.JoiningDate);
            const reliveDate = moment(item.RelivingDate);

            const fromCondition = fromDate
                ? joinDate.isSameOrAfter(moment(fromDate), 'day')
                : true;

            const toCondition = toDate
                ? joinDate.isSameOrBefore(moment(toDate), 'day')
                : true;

            const RfromCondition = RfromDate
                ? reliveDate.isSameOrAfter(moment(RfromDate), 'day')
                : true;

            const RtoCondition = RtoDate
                ? reliveDate.isSameOrBefore(moment(RtoDate), 'day')
                : true;

            const Fstatus = status
                ? item.Active?.trim()?.toLowerCase() === status?.trim()?.toLowerCase()
                : true;

            const Fname = name == "Sub_Contractor"
                ? item.Name?.toLowerCase()?.startsWith(name?.toLowerCase())
                : name == "Employees" ? !item.Name?.toLowerCase()?.startsWith("sub_contractor") : true;

            return fromCondition && toCondition && RtoCondition && RfromCondition && Fstatus && Fname;
        });

        setEmployeeListData(filteredData);
    }, [location.search, originalData]);


    const [apiStatus, SetApiStatus] = useState(undefined)
    const fetchEmployees = async () => {
        try {
            const response = await GetServiceCaller(
                `${API_URL}employee-history-details`);
            if (response.status === 200) {
                SetApiStatus(response?.status)
                console.log("response?.data", response?.data);

                const cleanedData = response?.data?.data;
                setEmployeeListData(cleanedData);
                setOriginalData(cleanedData)
                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch partnerMaster. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching PartnerMaster:", error);
        }
    };
    const handleEdit = (item) => {
        navigate(`/employee/history/edit/${item.ContactID}`);
    }




    const hanldeLinkColumn = (columnName, item) => {
        navigate('/employee-list/rujul/view/' + item.ContactID);

    }




    const [currentPage, setCurrentPage] = useState(1);
    const [isInitialized, setIsInitialized] = useState(false);
    const [activeContactIDKeys, setActiveContactIDKeys] = useState([]);
    const [itemsPerPage, setItemsPerPage] = useState(10);


    // Filter data based on search term
    const filteredData = useMemo(() => {
        return employeeListData.filter((item) =>
            Object.values(item).some((value) =>
                String(value).toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [employeeListData, searchTerm]);
    const recordsPerPageOption = [
        { value: 10, label: "10" },
        { value: 25, label: "25" },
        { value: 50, label: "50" },
        { value: 100, label: "100" },
        { value: filteredData.length, label: "All" },
    ];
    // Pagination logic
    const totalItems = filteredData.length;
    console.log("totalItems",totalItems);
    
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    console.log("totalPages",totalPages);
    
    // ✅ First group by ContactID (all rows belonging to same contact together)
    const groupedData = useMemo(() => {
        return filteredData.reduce((acc, item) => {
            if (!acc[item.ContactID]) {
                acc[item.ContactID] = [];
            }
            acc[item.ContactID].push(item);
            return acc;
        }, {});
    }, [filteredData]);
    
const groupedDataLength = Object.keys(groupedData).length;

    // ✅ Extract ContactIDs as an array
    const contactIDs = Object.keys(groupedData);

    const getCurrentItems = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
        const currentContactIDs = contactIDs.slice(startIndex, endIndex);

        // ✅ Only return the grouped data for current page
        return currentContactIDs.reduce((acc, id) => {
            acc[id] = groupedData[id];
            return acc;
        }, {});
    };

    const nestedData = getCurrentItems();
console.log("groupedData",groupedData);

    useEffect(() => {
        if (!loading && Object.keys(nestedData).length > 0 && !isInitialized) {
            // ❌ Remove setting all keys open
            // const allContactIDKeys = Object.keys(nestedData).map((_, i) => i.toString());
            // setActiveContactIDKeys(allContactIDKeys);

            setIsInitialized(true); // Just mark initialized
        }
    }, [nestedData, loading, isInitialized]);

    // Accordion handlers
    const handleClientToggle = (contactID) => {
        setActiveContactIDKeys((prev) =>
            prev.includes(contactID)
                ? prev.filter((key) => key !== contactID) // close it
                : [...prev, contactID]                    // open it
        );
    };
const defaultVisibleColumns = {
  Code: true,
  ContactName: true,
  FromDate: false,
  ToDate: false,
  Department: true,        // hidden by default
  Designation: true,       // hidden by default
  ImmediateSuperior: true,
  PracticeManager: true,   // hidden by default
};

const [columnVisibility, setColumnVisibility] = useState(defaultVisibleColumns);

    

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const toggleColumnVisibility = (columnId) => {
        setColumnVisibility((prev) => ({
            ...prev,
            [columnId]: !prev[columnId],
        }));
    };
    const EmployeeExportData = (data, columnVisibility, columns) => {
        // Get only visible columns
        const visibleColumns = columns.filter((col) => columnVisibility[col.id]);

        // Prepare export data
        const exportData = data.map((item) => {
            const row = {};
            visibleColumns.forEach((col) => {
                if (col.format) {
                    // if column has format (like JoiningDate)
                    row[col.label] = col.format(item[col.accessor]);
                } else {
                    row[col.label] = item[col.accessor] ?? "";
                }
            });
            return row;
        });

        return exportData;
    };



    // Calculate dynamic widths based on visible columns
const getColumnWidth = (columnName) => {
    const visibleColumns = Object.entries(columnVisibility).filter(([key, value]) => value);
    const totalColumns = visibleColumns.length;
    
    // Base widths for different column types
    const baseWidths = {
        Code: 120,
        ContactName: 250,
        Department: 180,
        Designation: 180,
        ImmediateSuperior: 200,
        JoiningDate: 150
    };
    
    return baseWidths[columnName] || 150;
};

// Get visible columns count for responsive adjustment
const visibleColumnCount = Object.values(columnVisibility).filter(Boolean).length;


    return (
        <>
            <div className="invoice-report-training">
                <div className="container-fluid" id="skill_section">
                    <div className="container-fluid" id="skill-table-area">
                        <div className="table-responsive">
                            <div className="d-flex justify-content-between">
                                <div className="d-flex">
                                    <div className="me-1">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setSearchTerm={setSearchTerm}
                                        />
                                    </div>

                                </div>
                                <div className="d-flex justify-content-end">
                                    <div className="me-1">
                                        <ExportToExcel
                                            data={EmployeeExportData(employeeListData, columnVisibility, columns)}
                                            filename="Employee_History.csv"
                                        />
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <div className="me-1">
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="tooltip-top">Column Chooser</Tooltip>
                                                }
                                            >
                                                <div className="btn-group me-2">
                                                    <button
                                                        type="button"
                                                        className="dropdown-toggle skill-button"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                        id="excel-btn"
                                                    >
                                                        <i className="bi bi-list"></i>
                                                    </button>
                                                    <ul
                                                        className="dropdown-menu p-2"
                                                        style={{
                                                            width: "200px", // Increased width
                                                            // maxHeight: '500px',  // Added max height with scroll
                                                            // overflowY: 'auto'  // Enable vertical scrolling if needed
                                                        }}
                                                    >
                                                        <div className="row">
                                                            <Form.Group style={{ width: "100%" }}>
                                                                {columns.map((column) => (
                                                                    <div
                                                                        key={column.id}
                                                                        className="mb-2"
                                                                        style={{
                                                                            whiteSpace: "normal", // Enable word wrap
                                                                            wordBreak: "break-word", // Break long words if needed
                                                                        }}
                                                                    >
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            id={`checkbox-${column.id}`}
                                                                            label={column.label}
                                                                            checked={columnVisibility[column.id]}
                                                                            onChange={() =>
                                                                                toggleColumnVisibility(column.id)
                                                                            }
                                                                        />
                                                                    </div>
                                                                ))}
                                                            </Form.Group>
                                                        </div>
                                                    </ul>
                                                </div>
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div
                                style={{
                                    overflowX: "auto",
                                    width: "100%",
                                    marginBottom: "10px",
                                }}
                                className="InvoiceScrollBar"
                            >
                               <Table bordered style={{ minWidth: "1100px", tableLayout: "fixed" }}>
    <thead id="thcolor" className="text-center">
        <tr>
            {columnVisibility.Code && (
                <th
                    style={{
                        width: `${getColumnWidth('Code')}px`,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                >
                    EMP ID
                </th>
            )}
            {columnVisibility.ContactName && (
                <th style={{ width: `${getColumnWidth('ContactName')}px` }}>Employee</th>
            )}
          
            {columnVisibility.Department && (
                <th style={{ width: `${getColumnWidth('Department')}px` }}>Department</th>
            )}
            {columnVisibility.Designation && (
                <th style={{ width: `${getColumnWidth('Designation')}px` }}>Designation</th>
            )}
            {columnVisibility.ImmediateSuperior && (
                <th style={{ width: `${getColumnWidth('ImmediateSuperior')}px` }}>Immediate Supervisor</th>
            )}
              {columnVisibility.FromDate && (
                <th style={{ width: `${getColumnWidth('FromDate')}px` }}>From</th>
            )}
              {columnVisibility.ToDate && (
                <th style={{ width: `${getColumnWidth('ToDate')}px` }}>To</th>
            )}
            {columnVisibility.PracticeManager && (
                <th style={{ width: `${getColumnWidth('PracticeManager')}px` }}>Practice Manager </th>
            )}
        </tr>
    </thead>
    <tbody>
        {loading ? (
            <tr>
                <td colSpan={visibleColumnCount} className="text-center py-4">
                    <div className="d-flex justify-content-center">
                        <FaSpinner className="spinner" />
                    </div>
                    <div className="text-muted mt-2">Loading</div>
                </td>
            </tr>
        ) : Object.keys(nestedData).length === 0 ? (
            <tr>
                <td colSpan={visibleColumnCount} className="text-center text-muted py-3">
                    No Record Found
                </td>
            </tr>
        ) : (
            Object.entries(nestedData).map(([contactID, contactData], contactIndex) => {
                console.log("contactID, contactData", contactID, contactData);

                const contactKey = contactIndex.toString();
                return (
                    <tr key={contactID}>
                        <td colSpan={visibleColumnCount} className="p-0">
                            <Accordion activeKey={activeContactIDKeys} style={{ border: "none" }}>
                                <Accordion.Item eventKey={contactKey}>
                                    <Accordion.Header
                                        onClick={() => handleClientToggle(contactKey)}
                                        className="AccordioninvoiceClient_header"
                                    >
                                        <span className="me-2 accordion_icon">
                                            <FontAwesomeIcon
                                                icon={activeContactIDKeys.includes(contactKey) ? faMinus : faPlus}
                                            />
                                        </span>

                                        <div className="flex-grow-1 text-black fw-bold">
                                            {contactData[0]?.ContactName}
                                            <span className="fst-italic">{`    ( DOJ :- ${moment(contactData[0]?.JoiningDate).format("DD-MMM-YYYY")}) `}</span>
                                        </div>

                                        <span className="me-2 accordion_icon">
                                            <i
                                                className="bi bi-pencil-square icons"
                                                style={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                    e.stopPropagation(); // ✅ prevents accordion toggle
                                                    handleEdit(contactData[0]);
                                                }}
                                            />
                                        </span>
                                    </Accordion.Header>

                                    <Accordion.Body className="no-padding">
                                        <Table
                                            bordered
                                            style={{
                                                tableLayout: "fixed",
                                                minWidth: "1100px",
                                            }}
                                        >
                                            <tbody>
                                                {contactData?.map((data, subIndex) => (
                                                    <tr key={subIndex} className="border">
                                                        {columnVisibility.Code && (
                                                            <td
                                                                style={{
                                                                    width: `${getColumnWidth('Code')}px`,
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {data.Code ? (
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        overlay={
                                                                            <Tooltip id="tooltip-top">
                                                                                {data.Code}
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <span>{data.Code}</span>
                                                                    </OverlayTrigger>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </td>
                                                        )}
                                                        {columnVisibility.ContactName && (
                                                            <td
                                                                style={{
                                                                    width: `${getColumnWidth('ContactName')}px`,
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {data.ContactName ? (
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        overlay={
                                                                            <Tooltip id="tooltip-top">
                                                                                {data.ContactName}
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <span>{data.ContactName}</span>
                                                                    </OverlayTrigger>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </td>
                                                        )}
                                                        
                                                        {columnVisibility.Department && (
                                                            <td
                                                                style={{
                                                                    width: `${getColumnWidth('Department')}px`,
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {data.Department ? (
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        overlay={
                                                                            <Tooltip id="tooltip-top">
                                                                                {data.Department}
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <span>{data.Department}</span>
                                                                    </OverlayTrigger>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </td>
                                                        )}
                                                        {columnVisibility.Designation && (
                                                            <td
                                                                style={{
                                                                    width: `${getColumnWidth('Designation')}px`,
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {data.Designation ? (
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        overlay={
                                                                            <Tooltip id="tooltip-top">
                                                                                {data.Designation}
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <span>{data.Designation}</span>
                                                                    </OverlayTrigger>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </td>
                                                        )}
                                                        {columnVisibility.ImmediateSuperior && (
                                                            <td
                                                                style={{
                                                                    width: `${getColumnWidth('ImmediateSuperior')}px`,
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {data.ImmediateSuperior ? (
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        overlay={
                                                                            <Tooltip id="tooltip-top">
                                                                                {data.ImmediateSuperior}
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <span>{data.ImmediateSuperior}</span>
                                                                    </OverlayTrigger>
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </td>
                                                        )}
                                                        {columnVisibility.FromDate && (
                                                            <td
                                                                style={{
                                                                    width: `${getColumnWidth('FromDate')}px`,
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {data.FromDate ? (
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        overlay={
                                                                            <Tooltip id="tooltip-top">
                                                                                {moment(data.FromDate).format("DD-MMM-YYYY")}
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <span>{moment(data.FromDate).format("DD-MMM-YYYY")}</span>
                                                                    </OverlayTrigger>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </td>
                                                        )}
                                                        {columnVisibility.ToDate && (
                                                            <td
                                                                style={{
                                                                    width: `${getColumnWidth('ToDate')}px`,
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {data.ToDate ? (
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        overlay={
                                                                            <Tooltip id="tooltip-top">
                                                                                {moment(data.ToDate).format("DD-MMM-YYYY")}
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <span>{moment(data.ToDate).format("DD-MMM-YYYY")}</span>
                                                                    </OverlayTrigger>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </td>
                                                        )}
                                                        {columnVisibility.PracticeManager && (
                                                            <td
                                                                style={{
                                                                    width: `${getColumnWidth('PracticeManager')}px`,
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {data.PracticeManager ? (
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        overlay={
                                                                            <Tooltip id="tooltip-top">
                                                                                {data.PracticeManager
                                                                               }
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <span>{
                                                                            data.PracticeManager}</span>
                                                                    </OverlayTrigger>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </td>
                                                        )}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </td>
                    </tr>
                );
            })
        )}
    </tbody>
</Table>
                            </div>
                            <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between mb-3 w-20">
                                <div className="d-flex justify-content-between px-">
                                    <span className="d-flex align-items-center">
                                        Showing {(currentPage - 1) * itemsPerPage + 1} -{" "}
                                        {Math.min(currentPage * itemsPerPage, totalItems)}{" "}
                                        of {groupedDataLength}
                                        <select
                                            value={itemsPerPage}
                                            onChange={(e) => {
                                                setItemsPerPage(Number(e.target.value));
                                                setCurrentPage(1);
                                            }}
                                            className="mx-2 form-select-sm"
                                        >
                                            {recordsPerPageOption.map((opt) => (
                                                <option key={opt.value} value={opt.value}>
                                                    {opt.label}
                                                </option>
                                            ))}
                                        </select>
                                    </span>

                                </div>
                                <div className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0 w-80">
                                    <Pagination
                                        itemsPerPage={itemsPerPage}
                                        totalItems={groupedDataLength}
                                        currentPage={currentPage}
                                        onPageChange={handlePageChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EmployeeHistorylist;